import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Input, Inject, PLATFORM_ID } from '@angular/core';
import LazyLoad from 'vanilla-lazyload';

import { Sizes, IMAGE_SIZES } from '../../interfaces/images';

@Component({
  selector: 'app-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
})
export class PictureComponent implements OnInit {
  @Input() readonly alt: string;
  @Input() readonly figcaption: string;
  @Input() readonly type: Sizes;
  @Input() readonly isBackground: boolean;
  @Input() readonly contain: boolean;
  @Input() public source: string;

  private isBrowser: boolean;
  public sizes: any[];
  public supportsNativeLoading: boolean;
  public backgroundClass: string;
  public containClass: string;
  public jpgQueryParam: string;

  constructor(@Inject(PLATFORM_ID) private platformId) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.backgroundClass = this.isBackground ? 'is-background' : '';
    this.containClass = this.contain ? 'contain' : '';
    this.source = this.addProtocol(this.source);
    this.jpgQueryParam = !this.pictureIsPng(this.source)
      ? '&q=70&fm=jpg&fl=progressive'
      : '';
    this.supportsNativeLoading =
      this.isBrowser && 'loading' in window['HTMLImageElement'].prototype;
    this.sizes = IMAGE_SIZES[this.type];

    if (!this.supportsNativeLoading) {
      const LAZYLOADCONFIG: any = {
        use_native: true,
        elements_selector: 'img[lazy-loading]',
        data_src: 'lazy-src',
        data_srcset: 'lazy-srcset',
      };

      if (this.isBrowser) {
        if (typeof window['lazyLoadInstance'] === 'undefined') {
          window['lazyLoadInstance'] = new LazyLoad(LAZYLOADCONFIG);
        }

        setTimeout(() => {
          // TODO: remove stupid DOM timeout hack (will update previous, but not itself without this)
          window['lazyLoadInstance'].update();
        }, 1);
      }
    }
  }

  private addProtocol(url: string): string {
    if (url && url.substr(0, 2) === '//') {
      return `https:${url}`;
    } else {
      return url;
    }
  }

  private pictureIsPng(source: string) {
    if (source) {
      return source.match(/.*\.png$/) !== null;
    } else {
      return false;
    }
  }
}
